<template>
  <div>
    <div class="page">
      <SiruiSearch
        :query="form"
        :rules="rules"
        :columns="formColumn"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="searchTrigger"
      ></SiruiSearch>
      <div class="main-content">
        <sirui-table
          ref="siruiTable"
          :buttonList="menuButtonList"
          :loading="load"
          :data="tableData"
          :paging="true"
          :reserve="false"
          :setting="false"
          :customVisible="true"
          :columns="columnListDefault"
          @chooseClick="chooseClick"
          @dblclickEvent="dblclickEvent"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          @handleSelectionChange="handleSelectionChange"
        >
          <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in columnListDefault"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title ? $t(item.title) : null"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template v-slot="{ row }">
              <template v-if="item.field === 'auditStatus'">{{
                getAuditStatus(row.auditStatus)
              }}</template>
              <template v-else-if="item.field === 'effectiveStatus'">{{
                getEffectiveStatus(row.effectiveStatus)
              }}</template>
              <template v-else-if="item.field === 'category'">{{
                getCategory(row.category)
              }}</template>
              <template v-else-if="item.field === 'priceNo'">
                <a @click="jumpToMeterDetail(row)" href="#" style="color: blue; cursor: pointer">{{
                  row[item.field]
                }}</a>
              </template>
              <template v-else>{{ row[item.field] }}</template>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
    </div>
    <AddAreaDialog
      :showDialog="showAddAreaDialog"
      :type="type"
      :priceId="priceId"
      @submit="addTransformer($event)"
      @closeDialog="showAddAreaDialog = false"
    >
    </AddAreaDialog>
  </div>
</template>
<script>
  import MeterAPI from '@/api/property/meterManagement';
  import { indexColumn, tableColumn } from './columns/columns.js';
  import AddAreaDialog from '../waterMeterPriceSetting/components/AddAreaDialog.vue';
  export default {
    name: 'WaterMeterPriceSetting',
    components: {
      AddAreaDialog,
    },
    computed: {
      formColumn() {
        return indexColumn(this);
      },
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
    },
    data() {
      return {
        form: {
          waterCompanyNo: '',
          spaceAreaId: '', //片区
          startDate: '', //起始月份
          endDate: '', //截止月份
          auditStatus: '', //审核状态
          effectiveStatus: '', //生效状态
          createPersonName: '', //创建人
          startGmtCreate: '',
          endGmtCreate: '',
        },
        rules: {
          endDate: [{ validator: this.checkEndTime, trigger: 'change' }],
        },
        type: 'add',
        priceId: '',
        multipleSelection: [],
        companyList: [], //公司列表
        spaceNameList: [],
        menuButtonList: [],
        tableData: [], // 表格数据
        baseFormData: { instructionNo: '' },
        showAddAreaDialog: false,
        load: false,
        columnListDefault: [],
      };
    },
    watch: {
      'form.waterCompanyNo': {
        handler(newVal) {
          this.getArea(newVal);
        },
        immediate: true,
      },
    },
    mounted() {
      this.form.waterCompanyNo = this.userInfo.companyCode;
      this.getPriceSetList();
      this.getCompany();
      this.getButtonList();
      this.columnListDefault = tableColumn();
    },
    methods: {
      //校验结束时间
      checkEndTime(rule, value, callback) {
        if (this.form.endDate == '') {
          callback();
        } else if (!this.form.startDate) {
          callback(new Error('请选择开始月份！'));
        } else if (Date.parse(this.form.startDate) > Date.parse(value)) {
          callback(new Error('结束月份必须大于开始月份！'));
        } else {
          callback();
        }
      },
      //每页条数
      handleSizeChange() {
        this.getPriceSetList();
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
      },
      //第几页
      handleCurrentChange() {
        this.getPriceSetList();
      },
      jumpToMeterDetail(row) {
        this.$router.push({
          path: '/property/waterPriceDetail',
          query: { type: 'detail', id: row.id },
        });
      },
      chooseClick(value) {
        this[value]();
      },
      add() {
        this.type = 'add';
        this.showAddAreaDialog = true;
        this.$refs.siruiTable.clearCheckboxReserve();
      },
      edit() {
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请选择数据!');
        } else if (this.multipleSelection.length > 1) {
          this.$message.warning('请选择一条数据');
        } else {
          if (
            this.multipleSelection[0].auditStatus == '2' ||
            this.multipleSelection[0].effectiveStatus == '2'
          ) {
            this.$message.warning('该状态不支持编辑！');
          } else {
            this.type = 'edit';
            this.priceId = this.multipleSelection[0].id.toString();
            this.showAddAreaDialog = true;
            this.$refs.siruiTable.clearCheckboxReserve();
          }
        }
      },
      async submit() {
        if (this.multipleSelection.length < 1) {
          return this.$message.warning('请选择数据!');
        }
        let idList = this.multipleSelection.map((item) => item.priceNo);

        const { data } = await this.$axios.post(MeterAPI.WATER_METER_PRICE_AUDIT_SUBMIT, idList);
        if (data.code == 0) {
          this.$message.success('提交审核成功');
          this.$refs.siruiTable.clearCheckboxReserve();
          this.getPriceSetList();
        } else {
          if (data.msg != '') {
            return this.$message.error(data.msg);
          }
          this.$message.error('提交审核失败');
        }
      },
      audit() {
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请选择数据');
        } else if (this.multipleSelection.length > 1) {
          this.$message.warning('请选择一条数据');
        } else {
          if (this.multipleSelection[0].auditStatus == '2') {
            this.$router.push({
              path: '/property/waterPriceAudit',
              query: { type: 'approval', id: this.multipleSelection[0].id },
            });
            this.$refs.siruiTable.clearCheckboxReserve();
          } else {
            this.$message.warning('该状态不支持审核');
          }
        }
      },
      invalid() {
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请选择数据');
        } else {
          let index = this.multipleSelection.findIndex(
            (item) => item.effectiveStatus == '1' || item.effectiveStatus == '3'
          );
          if (index != -1) {
            this.$message({
              type: 'warning',
              message: '请选择正确的数据！',
            });
          } else {
            this.$confirmAction('', '您确定要失效吗？')
              .then(async () => {
                let idList = this.multipleSelection.map((item) => item.priceNo);
                const { data } = await this.$axios.post(MeterAPI.WATER_METER_PRICE_LAPSE, idList);
                if (data.code == 0) {
                  this.$message.success('操作成功');
                  this.$refs.siruiTable.clearCheckboxReserve();
                  this.getPriceSetList();
                } else {
                  if (data.msg != '') {
                    return this.$message.error(data.msg);
                  }
                  this.$message.error('操作失败');
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }
        }
      },
      //双击事件
      dblclickEvent(value) {
        console.log('数据', value);
        this.$router.push({
          path: '/property/waterPriceDetail',
          query: { type: 'detail', id: value.row.id },
        });
      },
      // 审核状态
      getAuditStatus(status) {
        let auditStatus = {
          1: '待提交',
          2: '待审核',
          3: '审核通过',
        };
        return auditStatus[status] || '审核驳回';
      },
      // 生效状态
      getEffectiveStatus(status) {
        const effectiveStatus = {
          1: '待生效',
          2: '生效中',
        };
        return effectiveStatus[status] || '已失效';
      },
      getCategory(status) {
        const categoryStatus = this.$baseRequest.getDictListMapByType('water_meter_category');
        return categoryStatus.find((item) => item.value == status)?.label || '冷水水表';
      },
      // 重置按钮
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.multipleSelection = [];
        this.form.waterCompanyNo = this.userInfo.companyCode;
        this.getPriceSetList();
      },
      // 搜索按钮
      searchTrigger() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getPriceSetList();
      },
      // 选中的行
      handleSelectionChange(row) {
        this.multipleSelection = row;
        console.log(row);
      },

      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((res) => {
          this.menuButtonList = res;
        });
      },
      //获取公司信息
      async getCompany() {
        const { data } = await this.$axios.post(MeterAPI.GET_LIST_PERSON, {
          id: this.userInfo.userCode,
        });
        if (data.code == 0) {
          this.companyList = data.data.personCompanyInfo;
        }
      },
      // 获取片区数据
      async getArea(waterCompanyNo) {
        const { data } = await this.$axios.get(MeterAPI.GET_AREA, {
          id: '0',
          companyNo: waterCompanyNo,
        });
        if (data.code == 0) {
          this.spaceNameList = data.data;
        }
      },

      //获取列表数据
      async getPriceSetList() {
        let params = {
          ...this.form,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
          adminFlag: this.userInfo.adminFlag,
        };
        const { data } = await this.$axios.post(MeterAPI.WATER_METER_PRICE_LIST, params);
        if (data.code == 0) {
          this.tableData = data.data.records;
          this.$refs.siruiTable.setPageTotal(data.data.total);
          this.$refs.siruiTable.setPageSize(data.data.size);
          this.multipleSelection = [];
          this.$refs.siruiTable.clearCheckboxReserve();
        }
      },
      async addTransformer(formData) {
        this.showAddAreaDialog = false;
        var list = this.companyList.filter(
          (item) => item.personCompanyCode == this.userInfo.companyCode
        );
        let params = {
          ...formData,
          waterCompanyName: list[0].personCompanyName,
          waterCompanyNo: this.userInfo.companyCode,
        };
        const { data } = await this.$axios.post(
          this.type == 'add' ? MeterAPI.WATER_METER_PRICE_ADD : MeterAPI.WATER_METER_PRICE_UPDATE,
          params
        );
        if (data.code == 0) {
          this.getPriceSetList();
          this.showAddTransformerDialog = false;
          this.$message.success('操作成功');
        } else {
          if (data.msg != '') {
            return this.$message.error(data.msg);
          }
          this.$message.error('操作失败');
        }
      },
    },
  };
</script>
<style scoped lang="scss">
  .form {
    margin-top: 30px;
  }
  .item-margin {
    margin-left: 60px;
  }
  .button-group {
    margin-top: 20px;
  }
  .page {
    background-color: white;
    margin-top: 0px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 20px;
    height: 100%;
    top: 0;
    .page-row {
      text-align: right;
      margin-right: 20px;
      margin-bottom: 10px;
    }
    .el-divider--horizontal {
      display: block;
      height: 0.5px;
      width: 100%;
      margin: 1px 0;
    }
  }
</style>
